import { render, staticRenderFns } from "./settings-employee-bulk-message-permissions.vue?vue&type=template&id=0d84e952&scoped=true&"
import script from "./settings-employee-bulk-message-permissions.vue?vue&type=script&lang=js&"
export * from "./settings-employee-bulk-message-permissions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d84e952",
  null
  
)

export default component.exports